"use strict";
/**
 * Created by Ning Jiang on 12/7/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReelSpriteSymbol = void 0;
const ReelSpriteSymbolArea_1 = require("./ReelSpriteSymbolArea");
const gsap_1 = require("gsap");
const SymbolData_1 = require("./config/SymbolData");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
const Helper_1 = require("../../../utils/Helper");
class ReelSpriteSymbol extends ReelSpriteSymbolArea_1.ReelSpriteSymbolArea {
    constructor(ID, symName, state = ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL, type) {
        super(ID, symName, state, type);
    }
    changeState(newStateConfig) {
        if (!newStateConfig.forceState && this._symbolState.state === newStateConfig.state || this._useReelFakeSymbols)
            return this._timeLine;
        else
            return this.getStateAnimation(newStateConfig);
    }
    getStateAnimation(config) {
        if (this._timeLine) {
            this._timeLine.totalProgress(1);
            this._timeLine = Helper_1.Helper.timeLineNuller(this._timeLine);
        }
        this._timeLine = new gsap_1.TimelineMax();
        switch (config.state) {
            case ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL:
            case ReelSpriteSymbolArea_1.ReelSymbolStates.SPIN:
                this.textureAnimation(config);
                this._symbolState.set(config.state);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.CHANGE_SYMBOL:
                config.state = this._symbolState.state;
                this.textureAnimation(config);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.TRANSFORM:
                this.playTransformAnimation(config);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.IDLE:
                this.playIdle(config);
                this._symbolState.set(config.state);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.WIN:
                this.playWin(config);
                this._symbolState.set(config.state);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.LANDING:
            case ReelSpriteSymbolArea_1.ReelSymbolStates.ATTENTION:
                this.playAttention(config);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.STICKY:
                this.playSticky(config);
                break;
            case ReelSpriteSymbolArea_1.ReelSymbolStates.HIDE:
            case ReelSpriteSymbolArea_1.ReelSymbolStates.SHOW:
                this.ChangeVisibility(config);
                this._symbolState.set(config.state);
                break;
            default:
                Logger_1.Logger.warn("Using Unknown SymbolState: " + config.state);
                return this._timeLine;
        }
        return this._timeLine;
    }
    playTransformAnimation(config) {
        const toConf = config.newSym ? SymbolData_1.SymbolData.getSymbolConfig(config.newSym) : this._symConfig;
        const TEXTURES = SymbolData_1.SymbolData.getTextureFromConfig(toConf, this.state.state, this.stateType.state);
        let TEXTURES2 = SymbolData_1.SymbolData.getTextureFromConfig(toConf, config.state, this.stateType.state);
        this._timeLine = Helper_1.Helper.timeLineKiller(this._timeLine, new gsap_1.TimelineMax({
            onComplete: () => {
                this.changeSymbol(config.newSym);
                if (!this.isWild) {
                    this._overlaySprite.texture = this.currentStateAnim.texture;
                }
                this.changeState({ state: ReelSpriteSymbolArea_1.ReelSymbolStates.NORMAL });
                this.setActive(true);
            },
            onStart: () => this._oldAnimation.alpha = 1,
            repeat: config.repeat,
            repeatDelay: 0,
        }));
        if (TEXTURES2 == undefined)
            TEXTURES2 = TEXTURES;
        this._oldAnimation.setTexture(TEXTURES2);
        const duration = config.duration == undefined ? this._oldAnimation.totalDuration : config.duration;
        this._timeLine.add(this._oldAnimation.playAnimation({ duration: duration }));
        return this._timeLine;
    }
    playIdle(config) { return new gsap_1.TimelineMax(); }
    playWin(config) { return new gsap_1.TimelineMax(); }
    playAttention(config) { return new gsap_1.TimelineMax(); }
    playSticky(config) { return new gsap_1.TimelineMax(); }
    textureAnimation(config) {
        const toConf = config.newSym ? SymbolData_1.SymbolData.getSymbolConfig(config.newSym) : this._symConfig;
        const toType = config.type && this.stateType.state != config.type ? config.type : this.stateType.state;
        const TEXTURES = SymbolData_1.SymbolData.getTextureFromConfig(this._symConfig, this.state.state, this.stateType.state);
        let TEXTURES2 = SymbolData_1.SymbolData.getTextureFromConfig(toConf, config.state, toType);
        this.type = toType;
        this._symConfig = toConf;
        this.playTextureAnimation(TEXTURES, TEXTURES2, config.duration ? config.duration : 0, config.ease);
    }
    setSuperVisibility(value) { this.children.forEach(child => { child.visible = value; }); }
    playTextureAnimation(TextureFrom, TextureTo, duration, _ease) {
        if (TextureTo) {
            this._currentAnimation.setTexture(TextureTo);
            this._timeLine.fromTo(this._currentAnimation, duration, { alpha: 0 }, { alpha: 1, ease: _ease }, 0);
            if (TextureFrom) {
                this._oldAnimation.setTexture(TextureFrom);
                this._timeLine.fromTo(this._oldAnimation, duration, { alpha: 1 }, { alpha: 0, ease: _ease }, 0);
            }
        }
    }
    setVisibleForSymbol(value) {
        if (this._oldAnimation != undefined)
            this._oldAnimation.visible = value;
        if (this.currentStateAnim != undefined) {
            this.currentStateAnim.visible = value;
            this.currentStateAnim.alpha = value ? 1 : 0;
        }
    }
    attentionDarkness(alphaValue = 0.6, duration = 0.2) {
        this._subTimeline = Helper_1.Helper.timeLineKiller(this._subTimeline, new gsap_1.TimelineMax());
        if (!this.isNormalSym)
            return this._subTimeline;
        const startAlpha = this._attentionGFX.alpha;
        const toAlpha = alphaValue;
        if (this._attentionGFX.height != this.symbolHeight) {
            this._attentionGFX.beginFill(0x000000, 1);
            this._attentionGFX.drawRect(-this.symbolWidht * 0.5, -this.symbolHeight * 0.5, this.symbolWidht, this.symbolHeight);
            this._attentionGFX.height = this.symbolHeight;
            this._attentionGFX.endFill();
        }
        this._subTimeline.fromTo(this._attentionGFX, duration, { alpha: startAlpha }, { alpha: toAlpha });
        return this._subTimeline;
    }
    ChangeVisibility(config) {
        let alphaFrom = config.state == ReelSpriteSymbolArea_1.ReelSymbolStates.HIDE ? 1 : 0;
        let alphaTo = config.state == ReelSpriteSymbolArea_1.ReelSymbolStates.HIDE ? 0 : 1;
        this._timeLine.add([
            gsap_1.TweenLite.fromTo(this, config.duration ? config.duration : 0, { alpha: alphaFrom }, { alpha: alphaTo, ease: config.ease }),
        ]);
    }
}
exports.ReelSpriteSymbol = ReelSpriteSymbol;
//# sourceMappingURL=ReelSpriteSymbol.js.map